// Panel izinleri tek yerden okunur. Eksik izin listesi "yetkisiz" sayılır:
// backend her ucu ayrıca denetlediği için, çalışmayacak bir butonu göstermek
// yöneticiye yalnızca 403 hatası olarak döner.
import { useMemo } from 'react';
import { useAuth } from '../../context/AuthContext';

/**
 * Yalnızca affiliate izinleri taşıyan hesap (iş ortağına açılmış panel
 * hesabı) mı?
 *
 * Böyle bir hesap panelin iç işleyişini anlatan yüzeyleri (Kullanım Kılavuzu,
 * Yenilikler, panel asistanı) görmez: bunlar sağlayıcı adlarını, akışları ve
 * site güncellemelerini taşır ve iş ortağının bilmesi gereken şeyler
 * değildir. Karşılığı backend'dedir (`admin_security.is_affiliate_only`).
 * İş ortaklarının asıl yeri panel değil kendi portalıdır (`/ortak`).
 */
export const isAffiliateOnly = (permissions) => {
  const list = Array.isArray(permissions) ? permissions : [];
  return list.length > 0
    && !list.includes('*')
    && list.every((permission) => String(permission).startsWith('affiliate.'));
};

/** Verilen izin listesi için `can(permission)` denetleyicisi üretir.
 *
 * Denetleyici `affiliateOnly` bayrağını da taşır: menü, iç işleyişi anlatan
 * maddeleri (`internal`) bu bayrağa göre gizler.
 */
export const buildPermissionChecker = (permissions) => {
  const granted = new Set(permissions || []);
  const can = (permission) => {
    if (!permission) return true;
    if (granted.has('*')) return true;
    return Array.isArray(permission)
      ? permission.some((item) => granted.has(item))
      : granted.has(permission);
  };
  can.affiliateOnly = isAffiliateOnly(permissions);
  return can;
};

/** Oturumdaki yöneticinin izinleriyle çalışan denetleyici.
 *
 * `can` referansı izinler değişmedikçe sabit kalır; türetilmiş listeler
 * (görünür sekmeler gibi) bağımlılık olarak kullanabilsin diye.
 */
export const useAdminPermissions = () => {
  const { user } = useAuth();
  const permissions = user?.admin_permissions;
  const can = useMemo(
    () => buildPermissionChecker(permissions),
    [permissions],
  );
  return { can };
};
